/* --- STATE --- */

import { CloudProviders } from '@ariksa/cloud-account';
import { AccountType } from '@ariksa/cloud-account/dist/api';
import {
  AlertWorkflowResponse,
  ClientResponse,
  JiraProjects,
} from '@ariksa/notification/api';
import { IQueryState } from 'services/utils/QueryState';

import {
  IdentityProvider,
  IdentityProviderNameConfig,
  IdentityProviderServiceCreateRequest,
  IdentityProviderServiceDeleteRequest,
} from 'api/auth/api.pb';
import { ApiCallState, ApiCallStatus } from 'api/types';
import { IconTypes } from 'components/Icons';

export interface DeleteProviderProps
  extends IdentityProviderServiceDeleteRequest {
  onSuccess: () => void;
}

export interface CreateProviderProps
  extends IdentityProviderServiceCreateRequest {
  onRedirect: () => void;
}

export interface SSOProviderForm {
  createProvider: ApiCallStatus;
  formData: {
    providerConfig: IdentityProviderNameConfig;
  };
}

export interface SSO {
  providers: ApiCallState<IdentityProvider[]>;
  providerNames: ApiCallState<IdentityProviderNameConfig[]>;
  providerForm: SSOProviderForm;
  deleteProvider: ApiCallStatus;
}

export interface IntegrationsState {
  activeClient: IQueryState<ClientResponse>;
  client: IQueryState<Record<string, any>>;
  clients: ApiCallStatus & {
    //needed in alert workflow
    slack: Record<string, any>[];
    teams: Record<string, any>[];
    servicenow: Record<string, any>[];
    jira: Record<string, any>[];
    email: Record<string, any>[];
    sns: Record<string, any>[];
    elasticsearch: Record<string, any>[];
  };
  client_name: string;
  allClients: IQueryState<any>;
  currentTab: string;
  jiraProjects: IQueryState<JiraProjects>;
  jiraProjectDetails: IQueryState<JiraProjects>;
  workflows: IQueryState<AlertWorkflowResponse[]>;
  validateClient: IQueryState<any>;

  rediscoverAccount: IQueryState<any>;
  account: IQueryState<Record<string, any>>;

  codeRepositories: IQueryState<any>;

  sso: SSO;
}

export const DUMMY_API_KEY = '******************';

export type ContainerState = IntegrationsState;

export const IntegrationsTabs = {
  IdentityAndAccess: 'Identity & Access',
  Ticketing: 'Ticketing',
  Notification: 'Notification',
  Siem: 'SIEM',
  Sso: IconTypes.Sso,
  Saas: AccountType.Saas,
  Servicenow: IconTypes.Servicenow,
  Jira: IconTypes.Jira,
  Slack: IconTypes.Slack,
  Teams: IconTypes.Teams,
  Email: IconTypes.Email,
  Elasticsearch: IconTypes.Elasticsearch,
  Sms: IconTypes.Sms,
  Snowflake: CloudProviders.Snowflake,
  Github: CloudProviders.Github,
  Gitlab: CloudProviders.Gitlab,
  Bitbucket: CloudProviders.Bitbucket,
  AzureAd: CloudProviders.AzureAd,
  Okta: CloudProviders.Okta,
  Tableau: 'tableau',
};
